exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-edit{font-size:1.5em;color:#a3a3a3;font-weight:700}.centeras{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.label-input{font-size:13px;color:#757575;margin-bottom:5px}", ""]);

// exports
